import { provideDataItem } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfigWithoutHeaders } from '@/Data/pisaClient'

const whoAmIDataClassName = DataClassName.WHOAMI
const whoAmIEndpoint = PisaDataClassEndpoint.WHOAMI

export function pisaWhoAmIDataItem() {
  return provideDataItem(whoAmIDataClassName, {
    title: whoAmIDataClassName,
    restApi: createPisaRestApiConfigWithoutHeaders(whoAmIEndpoint),
  })
}
